import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { updateDivisionApi, deleteDivisionApi } from "../../../services/DivisonService";

const EditDivision = ({ divisionData, handleAfterDelete, handleAfterUpdate }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [formData, setFormData] = useState({ name: "" });
    const [errors, setErrors] = useState({});
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);


    // Show/Close Modals
    const handleShowEditModal = () => {
        setFormData({ name: divisionData?.name || "" });
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => setShowEditModal(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // Form Validation
    const validateForm = () => {
        let formErrors = {};
        if (!formData.name.trim()) formErrors.name = "Division name is required";
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    // Handle Input Change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            setIsSubmitLoading(true);
            const response = await updateDivisionApi(divisionData.id, formData);
            toast.success(response.data.message || "Division updated successfully");
            if (handleAfterUpdate) handleAfterUpdate({ ...divisionData, ...formData });
            setErrors({});
            setShowEditModal(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update division!");
        } finally {
            setIsSubmitLoading(false);
        }
    };

    // Handle Delete
    const handleDelete = async () => {
        try {
            setIsSubmitLoading(true);
            const response = await deleteDivisionApi(divisionData.id);
            if (handleAfterDelete) handleAfterDelete(divisionData.id);
            toast.success(response.data.message || "Division deleted successfully");
            setShowDeleteModal(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to delete division!");
        } finally {
            setIsSubmitLoading(false);
        }
    };


    return (
        <div>
            <Button
                variant="link"
                className="text-primary p-0 me-3"
                title="Edit"
                onClick={handleShowEditModal}
            >
                <i className="fas fa-edit"></i>
            </Button>

            <Button
                variant="link"
                className="text-danger p-0"
                title="Delete"
                onClick={handleShowDeleteModal}
            >
                <i className="fas fa-trash-alt"></i>
            </Button>


            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={handleCloseEditModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="divisionName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter division name"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className="text-end mt-3">
                            <Button variant="secondary" onClick={handleCloseEditModal}>
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                className="ms-2"
                                disabled={isSubmitLoading}
                            >
                                {isSubmitLoading ? "Updating..." : "Update"}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this division? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleDelete}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? "Deleting..." : "Delete"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EditDivision;
